//   document.addEventListener("DOMContentLoaded", function () {
//     const menuLinks = document.querySelectorAll(".menu-item.has-children > .menu-link");

//     menuLinks.forEach(link => {
//       link.addEventListener("click", function (e) {
//         e.preventDefault();

//         const parent = this.parentElement;

//         // Optional: close other active siblings if needed
//         const siblings = Array.from(parent.parentElement.children).filter(li => li !== parent);
//         siblings.forEach(sib => sib.classList.remove("active"));

//         // Toggle active on current
//         parent.classList.toggle("active");
//       });
//     });
//   });

// document.addEventListener('DOMContentLoaded', function () {
//     // Toggle parent menu based on tab click
//     document.querySelectorAll('.tab-item').forEach(tab => {
//       tab.addEventListener('click', () => {
//         const target = tab.getAttribute('data-menu-tab');
        
//         // Remove active from all
//         document.querySelectorAll('.tab-item').forEach(t => t.classList.remove('active'));
//         document.querySelectorAll('.parent-menu-item').forEach(p => p.classList.remove('active'));
  
//         // Add active to selected
//         tab.classList.add('active');
//         const activeMenu = document.querySelector(`.parent-menu-item[data-menu-content="${target}"]`);
//         if (activeMenu) activeMenu.classList.add('active');
//       });
//     });
  
//     // Toggle nested submenus
//     document.querySelectorAll('.menu-item.has-children > .menu-link').forEach(link => {
//       link.addEventListener('click', () => {
//         const parentItem = link.parentElement;
//         parentItem.classList.toggle('open');
//       });
//     });
  
//     // Activate the first tab/menu by default
//     document.querySelector('.tab-item')?.classList.add('active');
//     document.querySelector('.parent-menu-item')?.classList.add('active');
//   });





document.addEventListener('DOMContentLoaded', function () {
  // Tabs logic
  document.querySelectorAll('.tab-item').forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.getAttribute('data-menu-tab');
      $(tab).parent().addClass('open');
      // Remove active from all
      document.querySelectorAll('.tab-item').forEach(t => t.classList.remove('open'));
      document.querySelectorAll('.parent-menu-item').forEach(p => p.classList.remove('open'));

      // Add active to selected
      tab.classList.add('open');
      // const activeMenu = document.querySelector(`.parent-menu-item[data-menu-content="${target}"]`);
      $(`.parent-menu-item[data-menu-content="${target}"]`).addClass('open');
    });
  });

  // Recursive submenu toggle logic for ALL levels
  document.addEventListener('click', function (e) {
    const menuLink = e.target.closest('.menu-item.has-children > .menu-link');
    if (menuLink) {
      const parentItem = menuLink.parentElement;
      parentItem.classList.toggle('open');
    }
  });

  // Activate the first tab and menu group by default
  document.querySelector('.tab-item')?.classList.add('open');
  document.querySelector('.parent-menu-item')?.classList.add('open');
});

    // Toggle dropdown
    $('.desktop-dropdown-menu-handler').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Hide all other dropdowns
        $('.desktop-dropdown-menu-box').not($(this).next('.desktop-dropdown-menu-box')).hide();

        // Toggle the dropdown next to the clicked handler
        $(this).next('.desktop-dropdown-menu-box').toggle();
    });

    // Prevent clicks inside the menu from closing it
    $('.desktop-dropdown-menu-box').on('click', function (e) {
        e.stopPropagation();
    });

    // Close dropdown when clicking outside
    $(document).on('click', function () {
        $('.desktop-dropdown-menu-box').hide();
    });

        // $('.floating-list-account-item .has-dropdown > a').on('click', function (e) {
        //     e.preventDefault();

        //     const $dropdown = $(this).closest('li').find('.dropdown-content');

        //     $dropdown.slideToggle(200);

        //     $('.floating-list-account-item .dropdown-content').not($dropdown).slideUp(200);

        //     $(document).on('click.dropdownOutside', function (event) {
        //         if (!$(event.target).closest('.floating-list-account-item').length) {
        //             $dropdown.slideUp(200);
        //             $(document).off('click.dropdownOutside');
        //         }
        //     });
        // });
